<div fxLayout="row" fxLayout.xs="column" fxLayoutGap="16px">
  <div fxFlex="50%" fxFlex.xs="100%">
    <div fxLayout="column">
      <h2>Kellnerschichten</h2>
      <mat-radio-group [(ngModel)]="selectedOption">
        <mat-radio-button value="shiftStart">Schichtstart</mat-radio-button>
        <mat-radio-button value="shiftEnd">Schichtende</mat-radio-button>
      </mat-radio-group>

      <ng-container *ngIf="selectedOption === 'shiftStart'">
        <h3>Schichtstart</h3>
        <mat-form-field>
          <mat-label>Kellner_in wählen</mat-label>
          <mat-select [(ngModel)]="selectedWaiterGuid">
            <mat-option *ngFor="let waiter of waiters" [value]="waiter.guid"><span>{{ waiter.firstName }} {{ waiter.lastName }}</span><span *ngIf="superAdmin"> - {{ waiter.tenantName }}</span></mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field>
          <mat-label>Initialwechselgeld</mat-label>
          <input matInput [(ngModel)]="initialChange" name="initialChange">
        </mat-form-field>

        <button mat-raised-button color="accent" (click)="checkin()">Schicht und Code generieren</button>
      </ng-container>

      <ng-container *ngIf="selectedOption === 'shiftEnd'">
        <h3>Schichtende</h3>
        <mat-form-field>
          <mat-label>Kellner_in wählen</mat-label>
          <mat-select [(ngModel)]="selectedWaiterGuid" (valueChange)="onSelectedWaiterShift($event)">
            <mat-option *ngFor="let waiter of waitersShift" [value]="waiter.guid">{{ waiter.waiterName }}</mat-option>
          </mat-select>
        </mat-form-field>
        <p>Initialwechselgeld: {{ initialChangeCheckout | currency: 'EUR': 'symbol' }}</p>

        <mat-form-field>
          <mat-label>Gezählter Umsatz</mat-label>
          <input matInput type="text" [(ngModel)]="revenueByManualCounting" name="revenueByManualCounting">
        </mat-form-field>

        <p>Umsatz lt. System: {{ revenueBySystem | currency: 'EUR': 'symbol' }}</p>
        <p>Berechnetes Trinkgeld (auf Basis gezählter Umsatz): {{ calculateTip() | currency: 'EUR': 'symbol' }}</p>

        <mat-form-field>
          <mat-label>Behaltenes Trinkgeld</mat-label>
          <input matInput type="text" [(ngModel)]="tipKept" name="tipKept">
        </mat-form-field>

        <mat-form-field>
          <mat-label>Gespendetes Trinkgeld</mat-label>
          <input matInput type="text" [(ngModel)]="tipDonated" name="tipDonated">
        </mat-form-field>
        <h2>Vor Abschluss ist zu beachten, dass alle Stornierungen des Kellners abgeschlossen sind!</h2>
        <div class="unprocessedCancellations"><a [routerLink]="['/cancel-order-overview']" [ngClass]="unprocessedCancelledPositions > 0 ? 'text-red' : ''">Aktuell unbearbeitete Stornierungspositionen: {{unprocessedCancelledPositions}}</a></div>
          <button mat-raised-button color="accent" (click)="printWaiterReceipt()">Kellnerabrechnung drucken</button>
          <button class="btn-send-bottom" mat-raised-button color="accent" (click)="checkout()">Absenden</button>
      </ng-container>
    </div>
  </div>
</div>
